{
  "PROFILE_SETTINGS": {
    "LINK": "Nastavenia profilu",
    "TITLE": "Nastavenia profilu",
    "BTN_TEXT": "Aktualizovať profil",
    "DELETE_AVATAR": "Odstrániť avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar bol úspešne odstránený",
    "AVATAR_DELETE_FAILED": "Pri odstraňovaní avatara došlo k chybe, skúste to prosím znova",
    "UPDATE_SUCCESS": "Váš profil bol úspešne aktualizovaný",
    "PASSWORD_UPDATE_SUCCESS": "Vaše heslo bolo úspešne zmenené",
    "AFTER_EMAIL_CHANGED": "Váš profil bol úspešne aktualizovaný, prihláste sa prosím znova, keďže sa zmenili vaše prihlasovacie údaje",
    "FORM": {
      "PICTURE": "Profilová fotografia",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Obrázok e-mailového podpisu",
        "HINT": "Používa sa v e-mailových podpisoch. {'{{'}email_signature_picture{'}}'} sa nahradí adresou URL tohto obrázka (nie značkou obrázka) — použite ju ako zdroj obrázka (atribút src značky img) vo svojom podpise alebo podpise schránky. Ak nie je nastavený, nevloží sa nič.",
        "DELETE_SUCCESS": "Obrázok e-mailového podpisu bol úspešne odstránený",
        "DELETE_FAILED": "Pri odstraňovaní obrázka e-mailového podpisu došlo k chybe, skúste to prosím znova"
      },
      "AVATAR": "Profilový obrázok",
      "ERROR": "Prosím, opravte chyby vo formulári",
      "REMOVE_IMAGE": "Odstrániť",
      "UPLOAD_IMAGE": "Nahrať obrázok",
      "UPDATE_IMAGE": "Aktualizovať obrázok",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Vaša e-mailová adresa je vaša identita a používa sa na prihlásenie."
      },
      "SEND_MESSAGE": {
        "TITLE": "Skratka na odoslanie správ",
        "NOTE": "Môžete si vybrať klávesovú skratku (Enter alebo Cmd/Ctrl+Enter) podľa vašich preferencií pri písaní.",
        "UPDATE_SUCCESS": "Vaše nastavenia boli úspešne aktualizované",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Odosielajte správy stlačením klávesu Enter namiesto kliknutia na tlačidlo Odoslať."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Odosielajte správy stlačením klávesov Cmd/Ctrl + Enter namiesto kliknutia na tlačidlo Odoslať."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Rozhranie",
        "NOTE": "Prispôsobte si vzhľad vášho dashboardu.",
        "FONT_SIZE": {
          "TITLE": "Veľkosť písma",
          "NOTE": "Upravte veľkosť textu v celom dashboarde podľa vašich preferencií.",
          "UPDATE_SUCCESS": "Nastavenia písma boli úspešne aktualizované",
          "UPDATE_ERROR": "Pri aktualizácii nastavení písma došlo k chybe, skúste to prosím znova",
          "OPTIONS": {
            "SMALLER": "Menšie",
            "SMALL": "Malé",
            "DEFAULT": "Predvolené",
            "LARGE": "Veľké",
            "LARGER": "Väčšie",
            "EXTRA_LARGE": "Extra veľké"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Jazyk dashboardu",
          "NOTE": "Prepíšte jazyk účtu pre váš vlastný dashboard. Ponechajte prázdne pre použitie predvoleného nastavenia účtu.",
          "USE_ACCOUNT_DEFAULT": "Použiť predvolené nastavenie účtu",
          "API_SUCCESS": "Jazyk vášho dashboardu bol úspešne aktualizovaný",
          "API_ERROR": "Pri aktualizácii jazyka dashboardu došlo k chybe, skúste to prosím znova"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Jazyk správ",
          "NOTE": "Vyberte, či chcete zobraziť pôvodné správy alebo ich preklady",
          "ORIGINAL": "Pôvodné",
          "TRANSLATED": "Preložené"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Správanie pri vkladaní",
          "NOTE": "Vyberte, ako sa má spracovať vložený obsah pri vytváraní správ",
          "UPDATE_SUCCESS": "Vaše nastavenia vkladania boli úspešne aktualizované",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Zachovať celé formátovanie",
              "DESCRIPTION": "Pri vkladaní obsahu zachovajte celé formátovanie vrátane tabuliek, štýlov a ďalších HTML prvkov."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Iba text s odkazmi",
              "DESCRIPTION": "Pri vkladaní obsahu ho skonvertujte na čistý text, ale zachovajte klikateľné odkazy."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Iba čistý text",
              "DESCRIPTION": "Pri vkladaní obsahu odstráňte celé formátovanie a skonvertujte ho na čistý text."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Výška poľa odpovede",
          "NOTE": "Nastavte minimálnu výšku poľa odpovede ako percento výšky obrazovky. Platí len pre e-mailové konverzácie.",
          "UPDATE_SUCCESS": "Nastavenie výšky poľa odpovede bolo úspešne aktualizované",
          "PERCENT_LABEL": "Výška (% výšky obrazovky)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Predvolená",
              "DESCRIPTION": "Pole odpovede je spočiatku malé a rastie s dĺžkou správy."
            },
            "CUSTOM": {
              "HEADING": "Vlastná",
              "DESCRIPTION": "Pole odpovede má vždy aspoň zvolené percento výšky obrazovky."
            }
          }
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Osobný podpis správy",
        "NOTE": "Vytvorte jedinečný podpis správy, ktorý sa zobrazí na konci každej správy, ktorú odošlete z akejkoľvek schránky. Môžete tiež pridať vložený obrázok, ktorý je podporovaný v live chate, e-mailoch a API schránkach.",
        "BTN_TEXT": "Uložiť podpis správy",
        "API_ERROR": "Nepodarilo sa uložiť podpis! Skúste to znova",
        "API_SUCCESS": "Podpis bol úspešne uložený",
        "IMAGE_UPLOAD_ERROR": "Nepodarilo sa nahrať obrázok! Skúste to znova",
        "IMAGE_UPLOAD_SUCCESS": "Obrázok bol úspešne pridaný. Kliknite na uložiť pre uloženie podpisu",
        "IMAGE_UPLOAD_SIZE_ERROR": "Veľkosť obrázka musí byť menšia ako {size}MB",
        "DESCRIPTION": "Vytvorte jedinečný podpis správy, ktorý sa zobrazí na konci každého odoslaného e-mailu. Môžete zahrnúť aj vložený obrázok."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Podpis správy",
        "ERROR": "Podpis správy nemôže byť prázdny",
        "PLACEHOLDER": "Sem vložte svoj osobný podpis správy."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Heslo",
        "NOTE": "Aktualizácia hesla spôsobí odhlásenie na viacerých zariadeniach.",
        "BTN_TEXT": "Zmeniť heslo"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Prístupový token",
        "NOTE": "Tento token môžete použiť, ak vytvárate integráciu založenú na rozhraní API",
        "COPY": "Kopírovať",
        "REGENERATE": "Regenerovať",
        "REGENERATE_SUCCESS": "Prístupový token bol úspešne regenerovaný. Aktualizujte všetky integrácie používajúce starý token.",
        "REGENERATE_CONFIRM_TITLE": "Regenerovať prístupový token?",
        "REGENERATE_CONFIRM_MESSAGE": "Týmto sa zneplatní aktuálny token. Všetky integrácie používajúce starý token prestanú fungovať."
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Zvukové upozornenia",
        "NOTE": "Povoľte zvukové upozornenia v dashboarde pre nové správy a konverzácie.",
        "PLAY": "Prehrať zvuk",
        "ALERT_TYPES": {
          "NONE": "Žiadne",
          "MINE": "Priradené mne",
          "ALL": "Všetky",
          "ASSIGNED": "Moje priradené konverzácie",
          "UNASSIGNED": "Nepriradené konverzácie",
          "NOTME": "Otvorené konverzácie priradené iným"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Nevybrali ste žiadne možnosti, nebudete dostávať žiadne zvukové upozornenia.",
          "ASSIGNED": "Budete dostávať upozornenia na konverzácie priradené vám.",
          "UNASSIGNED": "Budete dostávať upozornenia na všetky nepriradené konverzácie.",
          "NOTME": "Budete dostávať upozornenia na konverzácie priradené iným.",
          "ASSIGNED+UNASSIGNED": "Budete dostávať upozornenia na svoje priradené konverzácie a na všetky nevybavené.",
          "ASSIGNED+NOTME": "Budete dostávať upozornenia na konverzácie priradené vám aj iným, ale nie na nepriradené.",
          "NOTME+UNASSIGNED": "Budete dostávať upozornenia na nevybavené konverzácie a tie, ktoré sú priradené iným.",
          "ASSIGNED+NOTME+UNASSIGNED": "Budete dostávať upozornenia na všetky konverzácie."
        },
        "ALERT_TYPE": {
          "TITLE": "Udalosti upozornení pre konverzácie",
          "NONE": "Žiadne",
          "ASSIGNED": "Priradené konverzácie",
          "ALL_CONVERSATIONS": "Všetky konverzácie"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tón upozornenia:"
        },
        "CONDITIONS": {
          "TITLE": "Podmienky upozornení:",
          "CONDITION_ONE": "Odosielať zvukové upozornenia iba vtedy, keď okno prehliadača nie je aktívne",
          "CONDITION_TWO": "Odosielať upozornenia každých 10 sekúnd, kým nebudú všetky priradené konverzácie prečítané"
        },
        "SOUND_PERMISSION_ERROR": "Automatické prehrávanie je vo vašom prehliadači zakázané. Ak chcete upozornenia počuť automaticky, povoľte zvuk v nastaveniach prehliadača alebo interagujte so stránkou.",
        "READ_MORE": "Čítať viac"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-mailové notifikácie",
        "NOTE": "Aktualizujte svoje preferencie e-mailových oznámení tu",
        "CONVERSATION_ASSIGNMENT": "Odosielať e-mailové upozornenia, keď mi je priradená konverzácia",
        "CONVERSATION_CREATION": "Odosielať e-mailové upozornenia pri vytvorení novej konverzácie",
        "CONVERSATION_MENTION": "Odosielať e-mailové upozornenia, keď som spomenutý v konverzácii",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Odosielať e-mailové oznámenia pri vytvorení novej správy v priradenej konverzácii",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Odosielať e-mailové upozornenia pri vytvorení novej správy v konverzácii, ktorej sa zúčastňujete",
        "SLA_MISSED_FIRST_RESPONSE": "Odosielať e-mailové upozornenia, keď konverzácia nesplní SLA pre prvú odpoveď",
        "SLA_MISSED_NEXT_RESPONSE": "Odosielať e-mailové upozornenia, keď konverzácia nesplní SLA pre ďalšiu odpoveď",
        "SLA_MISSED_RESOLUTION": "Odosielať e-mailové upozornenia, keď konverzácia nesplní SLA pre vyriešenie"
      },
      "NOTIFICATIONS": {
        "TITLE": "Predvoľby upozornení",
        "TYPE_TITLE": "Typ upozornenia",
        "EMAIL": "E-mail",
        "PUSH": "Push notifikácia",
        "TYPES": {
          "CONVERSATION_CREATED": "Je vytvorená nová konverzácia",
          "CONVERSATION_ASSIGNED": "Konverzácia vám bola priradená",
          "CONVERSATION_MENTION": "Ste spomenutý v konverzácii",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "V priradenej konverzácii je vytvorená nová správa",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "V konverzácii, ktorej sa zúčastňujete, je vytvorená nová správa",
          "SLA_MISSED_FIRST_RESPONSE": "Konverzácia nesplnila SLA pre prvú odpoveď",
          "SLA_MISSED_NEXT_RESPONSE": "Konverzácia nesplnila SLA pre ďalšiu odpoveď",
          "SLA_MISSED_RESOLUTION": "Konverzácia nesplnila SLA pre vyriešenie",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "V konverzácii bez dostupného agenta je vytvorená nová správa"
        },
        "BROWSER_PERMISSION": "Povoľte push notifikácie pre svoj prehliadač, aby ste ich mohli dostávať",
        "ALLOW_NOTIFICATION_DURING_CALL": "Povoliť push oznámenia počas hovoru",
        "TEST_PUSH": "Test",
        "TESTING": "Testuje sa...",
        "TEST_PUSH_DESCRIPTION": "Odoslať testovacie notifikácie na overenie vášho nastavenia",
        "TEST_NOTIFICATION_ERROR": "Nepodarilo sa odoslať testovaciu notifikáciu. Skúste to prosím znova.",
        "TEST_LOCAL_TITLE": "Testovacia notifikácia (lokálna)",
        "TEST_LOCAL_BODY": "Toto je lokálna notifikácia prehliadača. Ak toto vidíte, notifikácie prehliadača fungujú!"
      },
      "API": {
        "UPDATE_SUCCESS": "Vaše nastavenia oznámení sa úspešne aktualizovali",
        "UPDATE_ERROR": "Pri aktualizácii nastavení došlo k chybe, skúste to prosím znova"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push oznámenia",
        "NOTE": "Aktualizujte svoje predvoľby push oznámení tu",
        "CONVERSATION_ASSIGNMENT": "Odosielať push oznámenia, keď mi je priradená konverzácia",
        "CONVERSATION_CREATION": "Odosielať push upozornenia pri vytvorení novej konverzácie",
        "CONVERSATION_MENTION": "Odosielať push upozornenia, keď som spomenutý v konverzácii",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Odosielať push oznámenia pri vytvorení novej správy v priradenej konverzácii",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Odosielať push upozornenia pri vytvorení novej správy v konverzácii, ktorej sa zúčastňujete",
        "HAS_ENABLED_PUSH": "Pre tento prehliadač ste povolili push oznámenia.",
        "REQUEST_PUSH": "Povoliť push oznámenia",
        "SLA_MISSED_FIRST_RESPONSE": "Odosielať push upozornenia, keď konverzácia nesplní SLA pre prvú odpoveď",
        "SLA_MISSED_NEXT_RESPONSE": "Odosielať push upozornenia, keď konverzácia nesplní SLA pre ďalšiu odpoveď",
        "SLA_MISSED_RESOLUTION": "Odosielať push upozornenia, keď konverzácia nesplní SLA pre vyriešenie"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilová fotka"
      },
      "NAME": {
        "LABEL": "Vaše celé meno",
        "ERROR": "Prosím, zadajte platné celé meno",
        "PLACEHOLDER": "Prosím, zadajte svoje celé meno"
      },
      "DISPLAY_NAME": {
        "LABEL": "Zobrazované meno",
        "ERROR": "Prosím, zadajte platné zobrazované meno",
        "PLACEHOLDER": "Zadajte prosím zobrazované meno, ktoré sa bude zobrazovať v konverzáciách"
      },
      "AVAILABILITY": {
        "LABEL": "Dostupnosť",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Zaneprázdnený",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Dostupnosť bola úspešne nastavená",
        "SET_AVAILABILITY_ERROR": "Nepodarilo sa nastaviť dostupnosť, skúste to prosím znova"
      },
      "EMAIL": {
        "LABEL": "Vaša e-mailová adresa",
        "ERROR": "Prosím, zadajte platnú e-mailovú adresu",
        "PLACEHOLDER": "Zadajte prosím svoju e-mailovú adresu, ktorá sa bude zobrazovať v konverzáciách"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Aktuálne heslo",
        "ERROR": "Prosím, zadajte aktuálne heslo",
        "PLACEHOLDER": "Prosím, zadajte aktuálne heslo"
      },
      "PASSWORD": {
        "LABEL": "Nové heslo",
        "ERROR": "Zadajte heslo s dĺžkou 6 alebo viac znakov",
        "PLACEHOLDER": "Prosím, zadajte nové heslo"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Potvrďte nové heslo",
        "ERROR": "Potvrdzovacie heslo sa musí zhodovať s heslom",
        "PLACEHOLDER": "Prosím, zadajte ešte raz svoje nové heslo"
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automaticky prejsť na ďalšiu konverzáciu",
        "NOTE": "Po vyriešení aktuálnej konverzácie automaticky prepnúť na ďalšiu otvorenú konverzáciu",
        "UPDATE_SUCCESS": "Nastavenie automatickej navigácie bolo úspešne aktualizované"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formát zobrazenia náhľadu e-mailov v zozname konverzácií",
        "NOTE": "Zvoľte, čo sa zobrazí v zozname konverzácií pri konverzáciách z e-mailových schránok",
        "SUBJECT": "Predmet",
        "SUBJECT_WITH_NOTE": "Predmet a posledná správa, ak je interná poznámka",
        "UPDATE_SUCCESS": "Nastavenie náhľadu e-mailov bolo úspešne aktualizované"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Zakázať klávesové skratky",
        "NOTE": "Vypnúť všetky klávesové skratky v celej aplikácii",
        "UPDATE_SUCCESS": "Nastavenie klávesových skratiek bolo úspešne aktualizované"
      },
      "FOLDER_ORDER": {
        "TITLE": "Poradie priečinkov",
        "NOTE": "Prispôsobte poradie, v ktorom sa priečinky (vlastné zobrazenia) zobrazujú v bočnom paneli. Presuňte ich myšou a zmeňte poradie.",
        "NO_FOLDERS": "Neboli nájdené žiadne vlastné priečinky. Vytvorte priečinky na organizáciu svojich konverzácií."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfigurácia bočného panela",
        "NOTE": "Prispôsobte, ktoré sekcie sa zobrazia v bočnom paneli konverzácií.",
        "SAVE_BUTTON": "Uložiť konfiguráciu",
        "UPDATE_SUCCESS": "Konfigurácia bočného panela bola úspešne aktualizovaná",
        "UPDATE_ERROR": "Pri aktualizácii konfigurácie bočného panela došlo k chybe, skúste to prosím znova",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Všetky konverzácie",
          "ALL_CONVERSATIONS_DESC": "Zobraziť položku menu Všetky konverzácie v bočnom paneli",
          "INBOX": "Schránka",
          "INBOX_DESC": "Zobraziť hlavnú schránku s neprečítanými notifikáciami",
          "CONVERSATION_GROUPS": "Zmienky a bez odpovede",
          "CONVERSATION_GROUPS_DESC": "Zobraziť skupiny konverzácií Zmienky a Bez odpovede",
          "FOLDERS": "Priečinky",
          "FOLDERS_DESC": "Zobraziť vlastné zobrazenia (priečinky) pre organizované konverzácie",
          "TEAMS": "Tímy",
          "TEAMS_DESC": "Zobraziť konverzácie filtrované podľa priradenia tímov",
          "CHANNELS": "Schránky",
          "CHANNELS_DESC": "Zobraziť konverzácie filtrované podľa schránky",
          "LABELS": "Štítky",
          "LABELS_DESC": "Zobraziť konverzácie filtrované podľa štítkov"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Nastavenia telefónu",
        "NOTE": "Zadajte prihlasovacie údaje do vášho PBX systému.",
        "USERNAME": "Používateľské meno",
        "PASSWORD": "Heslo",
        "SUBMIT": "Uložiť",
        "USERNAME_INVALID": "Používateľské meno môže obsahovať len písmená, číslice a . _ - + — bez medzier a bez e-mailovej adresy.",
        "API": {
          "USERNAME_INVALID": "Používateľské meno nie je platné SIP používateľské meno. Používajte len písmená, číslice a . _ - + — bez medzier a bez e-mailovej adresy.",
          "USERNAME_TAKEN": "Toto používateľské meno už používa iný agent v tomto účte."
        }
      },
      "CHROME_EXTENSION": {
        "TITLE": "Rozšírenie pre Chrome",
        "NOTE": "Nainštalujte si naše rozšírenie pre Chrome, aby ste dostávali rozšírené notifikácie o prichádzajúcich telefónnych hovoroch.",
        "INSTALL_BUTTON": "Nainštalovať rozšírenie",
        "ALREADY_INSTALLED": "Rozšírenie je nainštalované"
      },
      "POSITION": {
        "LABEL": "Pozícia",
        "ERROR": "Zadajte prosím platnú pozíciu",
        "PLACEHOLDER": "Zadajte prosím svoju pozíciu"
      },
      "CUSTOM_LINE": {
        "LABEL": "Vlastný riadok",
        "ERROR": "Zadajte prosím platný vlastný riadok",
        "PLACEHOLDER": "Zadajte prosím svoj vlastný riadok"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Zmeniť dostupnosť",
    "CHANGE_ACCOUNTS": "Prepnúť účet",
    "SWITCH_ACCOUNT": "Prepnúť účet",
    "CONTACT_SUPPORT": "Kontaktovať podporu",
    "SELECTOR_SUBTITLE": "Vyberte účet z nasledujúceho zoznamu",
    "PROFILE_SETTINGS": "Nastavenia profilu",
    "KEYBOARD_SHORTCUTS": "Klávesové skratky",
    "APPEARANCE": "Zmeniť vzhľad",
    "SUPER_ADMIN_CONSOLE": "Konzola SuperAdmin",
    "DOCS": "Čítať dokumentáciu",
    "LOGOUT": "Odhlásiť sa",
    "REPORT_BUG": "Nahlásiť chybu"
  },
  "BUG_REPORT": {
    "TITLE": "Nahlásiť chybu",
    "DESCRIPTION_LABEL": "Popis problému",
    "DESCRIPTION_PLACEHOLDER": "Opíšte problém, na ktorý ste narazili...",
    "SUBMIT": "Odoslať hlásenie",
    "SUBMITTING": "Odosielanie...",
    "CANCEL": "Zrušiť",
    "SUCCESS": "Hlásenie chyby bolo úspešne odoslané. Ďakujeme!",
    "ERROR": "Nepodarilo sa odoslať hlásenie chyby. Skúste to prosím znova.",
    "VALIDATION_ERROR": "Pred odoslaním prosím opíšte problém"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "zostávajúcich dní skúšobnej verzie.",
    "TRAIL_BUTTON": "Kúpiť teraz",
    "DELETED_USER": "Odstránený používateľ",
    "EMAIL_VERIFICATION_PENDING": "Zdá sa, že ste ešte neoverili svoju e-mailovú adresu. Skontrolujte si prosím doručenú poštu kvôli overovaciemu e-mailu.",
    "RESEND_VERIFICATION_MAIL": "Znova odoslať overovací e-mail",
    "EMAIL_VERIFICATION_SENT": "Overovací e-mail bol odoslaný. Skontrolujte si prosím doručenú poštu.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Účet bol pozastavený",
      "MESSAGE": "Váš účet je pozastavený. Pre viac informácií kontaktujte tím podpory."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopírovať",
      "CODEPEN": "Otvoriť v CodePen",
      "COPY_SUCCESSFUL": "Kód bol úspešne skopírovaný do schránky"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Zobraziť viac",
      "SHOW_LESS": "Zobraziť menej"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Stiahnuť",
      "UPLOADING": "Nahrávanie...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Tento príbeh už nie je dostupný.",
      "RECORDING_UNAVAILABLE": "Táto nahrávka už nie je dostupná.",
      "DELETE_RECORDING": {
        "BUTTON": "Odstrániť nahrávku hovoru",
        "TITLE": "Odstrániť nahrávku hovoru?",
        "DESCRIPTION": "Všetky nahrávky tohto hovoru sa natrvalo odstránia z telefónnej ústredne a nebude možné ich obnoviť. Prepis a zhrnutie hovoru zostanú zachované.",
        "CONFIRM": "Odstrániť",
        "SUCCESS": "Nahrávka hovoru bola odstránená",
        "ERROR": "Nahrávku hovoru sa nepodarilo odstrániť. Skúste to, prosím, znova."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Zobraziť na mape"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Odoslať"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Tento obrázok už nie je dostupný.",
      "LOADING_FAILED": "Načítanie zlyhalo"
    }
  },
  "CONFIRM_EMAIL": "Overuje sa...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Pridať schránku"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Žiadne položky",
    "CURRENTLY_VIEWING_ACCOUNT": "Momentálne zobrazené:",
    "SWITCH": "Prepnúť",
    "INBOX_VIEW": "Zobrazenie schránky",
    "CONVERSATIONS": "Rozhovory",
    "INBOX": "Moja schránka",
    "ALL_CONVERSATIONS": "Všetky konverzácie",
    "MENTIONED_CONVERSATIONS": "Zmienky",
    "PARTICIPATING_CONVERSATIONS": "Zúčastnené",
    "UNATTENDED_CONVERSATIONS": "Bez odpovede",
    "REPORTS": "Reporty",
    "SETTINGS": "Nastavenia",
    "CONTACTS": "Kontakty",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asistenti",
    "CAPTAIN_DOCUMENTS": "Dokumenty",
    "CAPTAIN_RESPONSES": "Časté otázky",
    "HOME": "Domov",
    "AGENTS": "Agenti",
    "AGENT_BOTS": "Boti",
    "AUDIT_LOGS": "Auditné logy",
    "INBOXES": "Schránky",
    "NOTIFICATIONS": "Upozornenia",
    "CANNED_RESPONSES": "Uložené odpovede",
    "INTEGRATIONS": "Integrácie",
    "PROFILE_SETTINGS": "Nastavenia profilu",
    "ACCOUNT_SETTINGS": "Nastavenia účtu",
    "APPLICATIONS": "Aplikácie",
    "LABELS": "Štítky",
    "CUSTOM_ATTRIBUTES": "Vlastné atribúty",
    "AUTOMATION": "Automatizácia",
    "MACROS": "Makrá",
    "TEAMS": "Tímy",
    "BILLING": "Fakturácia",
    "CUSTOM_VIEWS_FOLDER": "Priečinky",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenty",
    "ALL_CONTACTS": "Všetky kontakty",
    "TAGGED_WITH": "Označené štítkom",
    "NEW_LABEL": "Nový štítok",
    "NEW_TEAM": "Nový tím",
    "NEW_INBOX": "Nová schránka",
    "REPORTS_CONVERSATION": "Rozhovory",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampane",
    "ONGOING": "Prebiehajúce",
    "ONE_OFF": "Jednorazové",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenti",
    "REPORTS_LABEL": "Štítky",
    "REPORTS_INBOX": "Schránka",
    "REPORTS_TEAM": "Tím",
    "SET_AVAILABILITY_TITLE": "Nastaviť sa ako",
    "SET_YOUR_AVAILABILITY": "Nastavte svoju dostupnosť",
    "AVAILABILITY_IMPERSONATING": "Uzamknuté počas prihlásenia za tohto používateľa",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Vlastné roly",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Prehľad",
    "REAUTHORIZE": "Pripojenie vašej schránky vypršalo, znova ju pripojte,\n aby ste mohli ďalej prijímať a odosielať správy",
    "HELP_CENTER": {
      "TITLE": "Centrum pomoci",
      "ARTICLES": "Články",
      "CATEGORIES": "Kategórie",
      "LOCALES": "Jazyky",
      "DICTIONARY": "Slovník",
      "SETTINGS": "Nastavenia"
    },
    "CHANNELS": "Kanály",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automaticky označiť ako offline",
      "INFO_TEXT": "Nech vás systém automaticky označí ako offline, keď nepoužívate aplikáciu alebo dashboard.",
      "INFO_SHORT": "Automaticky označiť ako offline, keď nepoužívate aplikáciu."
    },
    "DOCS": "Čítať dokumentáciu",
    "DATA_ASSISTANT": "Dátový asistent",
    "WHATSAPP_TEMPLATES": "Šablóny WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "REPORTS_PHONE": "Telefón",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Prehľad",
    "WALLBOARD_QUEUES": "Fronty",
    "WALLBOARD_AGENTS": "Prehľad agentov",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Reporty",
    "NO_WAITING_CALLERS": "žiadni čakajúci volajúci",
    "WAITING_CALLERS": "{count} čakajúcich volajúcich",
    "NEW_CONVERSATION": "Nová konverzácia",
    "DRAFT": "Koncept"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokované domény a kontakty",
    "DESCRIPTION": "Zoznam blokovaných e-mailových domén pre tento účet.",
    "NO_BLOCKED_DOMAINS": "Nenašli sa žiadne blokované domény.",
    "BLOCKED_CONTACTS_BTN": "Blokované kontakty"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Fakturácia",
    "DESCRIPTION": "Spravujte tu svoje predplatné, inovujte svoj plán a získajte viac pre svoj tím.",
    "CURRENT_PLAN": {
      "TITLE": "Aktuálny plán",
      "PLAN_NOTE": "Momentálne máte predplatený plán **{plan}** s **{quantity}** licenciami",
      "SEAT_COUNT": "Počet miest",
      "RENEWS_ON": "Obnovuje sa"
    },
    "VIEW_PRICING": "Zobraziť cenník",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Spravovať predplatné",
      "DESCRIPTION": "Zobrazte si predchádzajúce faktúry, upravte fakturačné údaje alebo zrušte svoje predplatné.",
      "BUTTON_TXT": "Prejsť do fakturačného portálu"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Spravujte využitie a kredity pre Captain AI.",
      "BUTTON_TXT": "Kúpiť viac kreditov",
      "DOCUMENTS": "Dokumenty",
      "RESPONSES": "Odpovede",
      "UPGRADE": "Captain nie je dostupný v bezplatnom pláne, inovujte teraz a získajte prístup k asistentom, copilotovi a ďalším funkciám."
    },
    "CHAT_WITH_US": {
      "TITLE": "Potrebujete pomoc?",
      "DESCRIPTION": "Máte problémy s fakturáciou? Sme tu, aby sme vám pomohli.",
      "BUTTON_TXT": "Četujte s nami"
    },
    "NO_BILLING_USER": "Váš fakturačný účet sa nastavuje. Obnovte stránku a skúste to znova."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ups! Nenašli sme žiadne účty. Ak chcete pokračovať, vytvorte nový účet.",
    "NEW_ACCOUNT": "Nový účet",
    "SELECTOR_SUBTITLE": "Vytvoriť nový účet",
    "API": {
      "SUCCESS_MESSAGE": "Účet bol úspešne vytvorený",
      "EXIST_MESSAGE": "Účet už existuje",
      "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Názov spoločnosti",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Odoslať",
      "CANCEL": "Zrušiť"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Zobraziť všetky skratky",
    "TITLE": {
      "OPEN_CONVERSATION": "Otvoriť konverzáciu",
      "RESOLVE_AND_NEXT": "Vyriešiť a prejsť na ďalšiu",
      "NAVIGATE_DROPDOWN": "Prechádzať položkami rozbaľovacej ponuky",
      "RESOLVE_CONVERSATION": "Vyriešiť konverzáciu",
      "GO_TO_CONVERSATION_DASHBOARD": "Prejsť na dashboard konverzácií",
      "ADD_ATTACHMENT": "Pridať prílohu",
      "GO_TO_CONTACTS_DASHBOARD": "Prejsť na dashboard kontaktov",
      "TOGGLE_SIDEBAR": "Prepnúť bočný panel",
      "GO_TO_REPORTS_SIDEBAR": "Prejsť na bočný panel reportov",
      "MOVE_TO_NEXT_TAB": "Presun na ďalšiu kartu v zozname konverzácií",
      "GO_TO_SETTINGS": "Prejsť na nastavenia",
      "SWITCH_TO_PRIVATE_NOTE": "Prepnúť na súkromnú poznámku",
      "SWITCH_TO_REPLY": "Prepnúť na odpoveď",
      "TOGGLE_SNOOZE_DROPDOWN": "Prepínať rozbaľovaciu ponuku odloženia",
      "AI_ASSIST_MENU": "AI asistent",
      "AI_ASSIST_GRAMMAR": "Opraviť gramatiku",
      "AI_ASSIST_UNIFY_LANG": "Zjednotiť jazyk správy"
    }
  }
}
